var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.077 6.06687C14.1687 5.61404 14.5299 5.25195 14.9827 5.25195H16.7931C17.4201 5.25195 17.6988 5.80012 17.6988 6.3382C17.2459 9.50712 14.3493 12.0417 10.9998 12.0417C7.65028 12.0417 4.75361 9.5062 4.30078 6.3382C4.30078 5.80012 4.57853 5.25195 5.20645 5.25195H7.01686C7.4697 5.25195 7.83178 5.61404 7.92161 6.06779C8.28461 7.51612 9.46161 8.5107 10.9998 8.5107C12.5389 8.5107 13.7159 7.5152 14.077 6.06687Z",
    stroke: "#979592",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.73529 11.6528C9.46194 11.9108 10.2275 12.0423 10.9985 12.0415C11.7869 12.0415 12.5495 11.9013 13.2618 11.6455V20.2668C13.2618 20.5099 13.1652 20.743 12.9933 20.9149C12.8214 21.0868 12.5882 21.1834 12.3451 21.1834H9.65104C9.40793 21.1834 9.17477 21.0868 9.00286 20.9149C8.83095 20.743 8.73438 20.5099 8.73438 20.2668V11.6528H8.73529Z",
    stroke: "#979592",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9688 9.86888C16.8818 8.89996 17.5087 7.6753 17.6985 6.33788C17.6985 6.30855 17.6985 6.2783 17.6967 6.24805H19.1358C19.3789 6.24805 19.6121 6.34462 19.784 6.51653C19.9559 6.68844 20.0525 6.9216 20.0525 7.16471V8.95221C20.0525 9.19533 19.9559 9.42849 19.784 9.60039C19.6121 9.7723 19.3789 9.86888 19.1358 9.86888H15.9688Z",
    stroke: "#979592",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.707 10.1322C15.7969 10.047 15.8839 9.95806 15.9683 9.86914H18.9658V15.3004H15.707V10.1322Z",
    stroke: "#979592",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.73529 7.57218C9.03195 7.87017 9.38468 8.10645 9.77313 8.2674C10.1616 8.42835 10.5781 8.51078 10.9985 8.50993C11.9115 8.50993 12.698 8.15976 13.2618 7.57126V1.7321C13.2618 1.48898 13.1652 1.25582 12.9933 1.08392C12.8214 0.912007 12.5882 0.81543 12.3451 0.81543H9.65104C9.40793 0.81543 9.17477 0.912007 9.00286 1.08392C8.83095 1.25582 8.73438 1.48898 8.73438 1.7321V7.57218H8.73529Z",
    stroke: "#979592",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.03193 9.86888C5.11802 8.89996 4.49193 7.6753 4.30035 6.33788L4.3031 6.24805H2.86393C2.62082 6.24805 2.38766 6.34462 2.21575 6.51653C2.04384 6.68844 1.94727 6.9216 1.94727 7.16471V8.95221C1.94727 9.19533 2.04384 9.42849 2.21575 9.60039C2.38766 9.7723 2.62082 9.86888 2.86393 9.86888H6.0301H6.03193Z",
    stroke: "#979592",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.29391 10.1322C6.20418 10.0469 6.11676 9.95916 6.03174 9.86914H3.03516V14.3837C3.03516 14.6268 3.13173 14.86 3.30364 15.0319C3.47555 15.2038 3.70871 15.3004 3.95182 15.3004H5.37724C5.62035 15.3004 5.85351 15.2038 6.02542 15.0319C6.19733 14.86 6.29391 14.6268 6.29391 14.3837V10.1322Z",
    stroke: "#979592",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwgIcon);
export default __webpack_public_path__ + "static/media/twgIcon.4471a94af84d1faad0ecae22edc33f9b.svg";
export { ForwardRef as ReactComponent };